<template>
  <div class="d-inline">
    <b-button
      @click="showModal"
      size="sm"
      :variant="isCompanyNameDefined ? 'outline-primary' : 'primary'"
      :class="isCompanyNameDefined ? '' : 'mr-2'"
    >
      <i v-if="!isCompanyNameDefined" class="fa fa-plus" aria-hidden="true"></i>
      {{ title }}
    </b-button>

    <b-modal
      size="xl"
      :id="modalId"
      :ref="modalId"
      @ok="saveRecord"
      :ok-title="isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
    >
      <template slot="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
      </template>
      <div>
        <form>
            <h5>
                Select an invoice to create the RMA
            </h5>
            <b-row>
                <b-col>
                  <div div class="d-flex justify-content-start align-items-end mb-2">
					          <b-form-group label="Invoice Number" class="mr-2">
                        <b-form-input v-model="invoiceFilters.invoiceNumber" @input="onSearch" size="sm" />
                    </b-form-group>
                    <b-form-group label="Sales Order Number" class="mr-2">
                        <b-form-input v-model="invoiceFilters.soNumber" @input="onSearch" size="sm" />
                    </b-form-group>
                    <b-form-group label="Company" class="mr-2">
                        <b-form-input v-model="invoiceFilters.companyName"  @input="onSearch" size="sm" />
                    </b-form-group>
                    <b-form-group label="Sales Rep" class="mr-2">
                        <b-form-input v-model="invoiceFilters.salesRep" size="sm" />
                    </b-form-group>
                    <b-form-group label="RMA Date" class="mr-2">
                        <b-form-select v-model="invoiceFilters.requestDate" @change="onSearch">
                            <option v-for="option in requestDate" :key="option" :value="option">
                                {{option }}</option>
                        </b-form-select>
                    </b-form-group>
                    <date-range-picker ref="dateRangePicker" :handleSearch="onSearch"></date-range-picker>
                    <b-button class="mr-2" size="sm" @click="onClear">Clear</b-button>
                </div>
                </b-col>
            </b-row>
            <h5>
              Invoices
              <i v-show="isLoadingInvoice" class="fa fa-spinner fa-pulse fa-fw"></i>
            </h5>
            <b-row>
                <b-col>
                <div class="grid-container mb-2">
                    <grid-component
                      isResizable
                      isReorderable
                      :gridId="gridId"
                      :itemData="itemData"
                      :fields="fields"
                      :handleRowClick="onRowClick"
                     />
                </div>
                </b-col>
            </b-row>
            <h5 v-if="selectedRowItemId > 0">
              Select invoice lines for inventory returned...
              <i v-show="isLoadingLines" class="fa fa-spinner fa-pulse fa-fw"></i>
            </h5>
            <div v-if="selectedRowItemId > 0 && invoiceLineArr.length > 0">
              <b-row v-for="(line, index) in invoiceLineArr" :key="index" class="mt-1">
                  <b-col>
                    <table>
                      <tr>
                        <td>
                          <input type="checkbox" :value="line.id" v-model="checkedInvoiceLineIds" />
                        </td>
                        <td>
                          <dt>Part Number</dt>
                          <dd>{{ line.partNumber || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>Quantity Shipped</dt>
                          <dd>{{ line.quantity || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>Date Code</dt>
                          <dd>{{ line.dateCode || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>COO</dt>
                          <dd>{{ line.countryOfOriginName || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>RoHS</dt>
                          <dd>{{ line.leadFree || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>Lot</dt>
                          <dd>{{ line.lotCode || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>Revision</dt>
                          <dd>{{ line.revision || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>Packaging</dt>
                          <dd>{{ line.package || '&nbsp;' }}</dd>
                        </td>
                        <td>
                          <dt>SPQ</dt>
                          <dd>{{ line.piecePerPkg || '&nbsp;' }}</dd>
                        </td>
                      </tr>
                    </table>
                    <div class="d-flex justify-content-start align-items-end mb-2" v-if="checkedInvoiceLineIds.indexOf(line.id) > -1">
                        <b-form-group label="Quantity Returned" class="mr-2">
                            <b-form-input type="number" :max="line.quantity" v-model="line.returnQty" size="sm"
                              @blur="line.returnQty = line.returnQty > line.quantity ? line.quantity : line.returnQty < 0 ? 0 : line.returnQty" />
                        </b-form-group>
                        <b-form-group label="Reason of Returning" class="mr-2" >
                            <b-form-select v-model="line.returnReasonId" size="sm">
                              <option v-for="(item) in sortSelect(rmaReasons)" :key="item.id" :value="item.id">{{item.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="Comments" class="mr-2">
                            <b-form-input v-model="line.returnComments" size="sm" />
                        </b-form-group>
                    </div>
                  </b-col>
              </b-row>
            </div>
        </form>
      </div>
      <template slot="modal-footer">
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Customer's Action" class="mr-2">
              <b-form-select v-model="rmaValues.rmaTermsId">
                  <option v-for="terms in sortSelect(rmaTerms)" :key="terms.id" :value="terms.id"> {{ terms.name }} </option>
              </b-form-select>
          </b-form-group>
          <b-form-group label="Refund/Replace/Credit" class="mr-2">
              <b-form-select v-model="rmaValues.rmaActionId">
                  <option v-for="action in sortSelect(rmaActions)" :key="action.id" :value="action.id"> {{ action.name }} </option>
              </b-form-select>
          </b-form-group>
        </div>
        <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
        <b-button variant="primary" @click="saveRecord()" :disabled="isSaving || selectedRowItemId == 0">
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import VueSimpleSuggest from 'vue-simple-suggest';
import DateRangePicker from '@/shared/components/DateRangePicker';
import GridSettings from '@/shared/components/GridSettings';
import { required } from 'vuelidate/lib/validators';
import { date } from '@/shared/filters';
import GridComponent from '@/shared/components/GridComponent';

import { AUTO_COMPLETE_STYLES, ADD_RECORD_FILTERS } from '@/shared/constants';
import { GRID_ID, MODAL_ID, SAVE_SETTINGS_DELAY, PAGE_SIZE, REQUEST_DATE } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import invoiceFields from '@/pages/Invoices/fields';
import invoiceLineFields from './modifiedInvoiceLineField';
import inventoryUsedField from './inventoryUsedField';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    GridSettings,
    VueSimpleSuggest,
    DateRangePicker,
    GridComponent
  },
  props: {
    companyName: [String],
    invoiceId: [Number, String],
    salesOrderId: [Number, String],
    modalId: {
      type: String,
      default: 'add-customer-rma'
    }
  },
  data() {
    return {
      date,
      ADD_RECORD_FILTERS,
      fields: invoiceFields,
      lineFields: invoiceLineFields,
      inventoryField: inventoryUsedField,
      prepareColumnsData,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      requestDate: REQUEST_DATE,
      checkedRowItemIds: [],
      checkedInvoiceLineIds: [],
      checkedInventoryReturnedIds: [],
      title: 'Add Customer RMA',
      selectedRowItemId: 0,
      selectedRowItemLineId: 0,
      rmaValues: {},
      linesReturnedValues: {},
      enableLineValues: false,
      invoiceLinesSelected: {},
      requiredFields: [
        'quantityReturning', 'rmaReasonId', 'rmaTermsId'
      ],
      isLoadingInvoice: false,
      isLoadingLines: false,
      isLoadingInventory: false,
      isSaving: false,
      invoiceLineArr: []
    }
  },
  validations: {
    filterValObj: {
      companyId: { required },
    },
  },
  filters: {
    date,
  },
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('lookup', ['rmaReasons', 'rmaActions', 'rmaTerms']),
    ...mapGetters('invoices', [
        'invoices',
        'selectedItemId',
        'filters',
    ]),
    ...mapState('invoices', [
        'pageInfo',
    ]),
    ...mapState('invoiceLines', ['invoiceLinesRma']),
    ...mapState('pickTicket', ['pickTicketLinesByInvoiceLine']),
    gridId: function() {
      return GRID_ID.INVOICES;
    },
    gridLineId: function() {
      return GRID_ID.INVOICES_LINES
    },
    gridInventoryId: function() {
      return GRID_ID.RMA_INVENTORY
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    disableAdd() {
      return this.filterValObj.companyId == 0;
    },
    itemData() {
      if (this.invoices == undefined || this.invoices.length === 0) return [];
		  return this.invoices.map((invoice) => ({ ...invoice, selected: invoice.id === this.selectedRowItemId }));
    },
    returnedInvoiceLine() {
      return this.invoiceLineArr.filter(x => this.checkedInvoiceLineIds.indexOf(x.id) > -1);
    },
    isSaveEnable() {
      return this.validateRequiredFields();
    },
    isCompanyNameDefined() {
      return this.companyName != undefined;
    },
    invoiceFilters() {
      return this.filters['crmaAddPage'] || {}
    }
  },
  methods: {
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('invoices', ['getAll', 'search']),
    ...mapActions('invoiceLines', [ 'getInvoiceLinesRma' ]),
    ...mapActions('customerrmas', [ 'manage' ]),
    ...mapActions('pickTicket', [ 'getPickTicketsByInvoiceLine' ]),
    /*...mapMutations('pickTicket', [ 'setPickTicketLinesByInvoiceLine' ]),*/
    ...mapMutations('pickTicket', {pickTicketSetItem : 'setItem'}),
    ...mapMutations('invoiceLines', {invoiceLinesSetItem: 'setItem'}),
    ...mapMutations('invoices', {invoiceSetItem:'setItem'}),
    showModal() {
      this.invoiceSetItem({ resource:'filterPage', payload: 'crmaAddPage' });
      Object.keys(this.invoiceFilters).forEach(filterName => {
        this.invoiceFilters[filterName] = null;
      });
      // Proforma Invoice should be excluded
      this.invoiceFilters.isProforma = false;
      if (this.isCompanyNameDefined) {
        this.invoiceFilters.companyName = this.companyName;
        this.onSearch();
      } else if (this.invoiceId > 0) {
        this.invoiceFilters.invoiceNumber = this.invoiceId;
        this.onSearch();
      } else if (this.salesOrderId > 0) {
        this.invoiceFilters.soNumber = this.salesOrderId;
        this.onSearch();
      } else {
        /*this.setInvoiceList([]);*/
        this.invoiceSetItem({ resource: 'invoices', payload: [] });
      }

      this.$bvModal.show(this.modalId);
    },
    async onRowClick(row) {
      this.selectedRowItemId = this.rmaValues.invoiceId = row.dataItem.id;
      try {
        if (this.selectedRowItemId) {
          this.isLoadingLines = true;
          await this.getInvoiceLinesRma(this.selectedRowItemId).then(() => {
            this.invoiceLineArr = this.invoiceLinesRma.map((returnLine) => ({
              ...returnLine,
              returnQty: 0,
              returnReasonId: 0,
              returnComments: null
            }));
            this.checkedInvoiceLineIds = [];
          });
          this.isLoadingLines = false;
        }
      } catch (e) {
        this.isLoadingLines = false;
      }
    },
    async onRowLineClick(row) {
      try {
        this.isLoadingInventory = true;
        this.selectedRowItemLineId = row.dataItem.id;
        // await this.getPickTicketsByInvoiceLine(row.dataItem.id);
        this.isLoadingInventory = false;
      } catch (e) {
        this.isLoadingInventory = false;
        /*console.log(e.message);*/
      }
    },
    clearLineValues() {
      //console.log('Called clear Line')
      this.checkedInvoiceLineIds = [];
      this.checkedInventoryReturnedIds = [];
      this.selectedRowItemLineId = 0;
      /*this.setInvoiceLinesRma([]);*/
      this.invoiceLinesSetItem({ resource: 'invoiceLinesRma', payload: [] });
      /*this.setPickTicketLinesByInvoiceLine([]);*/
      this.pickTicketSetItem({ resource: 'pickTicketLinesByInvoiceLine', payload: [] });
    },
    onSearch: debounce(function() {
      this.isLoadingInvoice = true;
      this.search({ 'filters': this.invoiceFilters, page: 'crmaAddPage' });
      this.isLoadingInvoice = false;
      this.clearLineValues();

      if (this.itemData.length == 1) {
        //auto selects the only one invoice
        this.onRowClick({ dataItem: this.itemData[0] })
      }
		}, SEARCH_DEBOUNCE_TIME),
    onClear() {
      Object.keys(this.invoiceFilters).forEach(filterName => {
          this.invoiceFilters[filterName] = null;
      });
      this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
      this.invoiceFilters.isProforma = false;
      this.search({ 'filters': this.invoiceFilters, page: 'crmaAddPage' });
    },
    async saveRecord() {
      this.$snotify.info('Processing RMA', 'RMA');
      try {
        this.isSaving = true;
        await this.manage({
          rmaDto: {
            ...this.rmaValues,
            returnedInvoiceLine: this.returnedInvoiceLine
          }
        }).then((res) => {
          this.isSaving = false;
          this.onClear();
          this.$bvModal.hide(this.modalId);
          this.$router.push({
            name: 'customerrmas.edit',
            params: {id: res},
          });
        });
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }

    },
  },
  mounted() {
    
  }

}
</script>
<style scoped>
table {
  width: 100%;
  cursor: context-menu;
}
td {
  padding-left: 10px;
  white-space: nowrap;
}
</style>
